import * as React from "react";

const PaginationArrowLeft: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 11 18"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M0 9l.992.991 7.023 7.014.997.995L11 16.014l-.992-.991L3.977 9l6.027-6.023.996-.991L9.012 0 8.02.995.996 8.009z" />
        </svg>
    );
};

export default React.memo(PaginationArrowLeft);
